module.exports = __webpack_public_path__ + "static/media/geese512x384.8891f304.webp";